import { render } from "./SplitButton.vue?vue&type=template&id=23a30c5c"
import script from "./SplitButton.vue?vue&type=script&lang=js"
export * from "./SplitButton.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SplitButton.vue?vue&type=style&index=0&id=23a30c5c&lang=scss&module=true"
cssModules["$style"] = style0
import "./SplitButton.vue?vue&type=style&index=1&id=23a30c5c&lang=scss"
import "./SplitButton.vue?vue&type=style&index=2&id=23a30c5c&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__